import axiosInstance from "../services/axiosInstance";
import { axiosWithAbort } from "../services/axiosWithAbort";
import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
} from "../services/toast";
////////產出隨機UUID
const generateDeviceId = () => {
  return Array.from(crypto.getRandomValues(new Uint8Array(16)))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 16);
};

export const loginAPI = {
  ////////登入用API
  async login(act, psw) {
    const UUID = generateDeviceId();
    const requestBody = {
      email: act,
      password: psw,
      ////////暫時先寫格式 先不帶內容
      device_id: UUID,
      device_info: navigator.userAgent,
    };
    try {
      const response = await axiosInstance.post(
        `/user/accountuser/login`,
        requestBody,
        { skipAuth: true },
      );

      if (response.data && response.data.success === false) {
        if (response.data.error_code === "FORBIDDEN") {
          throw response.data;
        }
        handleAPIError(null, {
          apiData: response.data,
          scenarioCode: MESSAGE_CODES.LOGIN_FAILED
        });
      }

      return response.data.data;
    } catch (err) {
      console.error("Login Fail!", err);
      // Check if it's the subscription expired error (FORBIDDEN)
      const errorData = err?.response?.data || (err?.error_code ? err : null);
      if (errorData && errorData.error_code === "FORBIDDEN") {
        throw errorData;
      }
      handleAPIError(err, {
        scenarioCode: MESSAGE_CODES.LOGIN_FAILED,
        throwError: false
      });
      throw err;
    }
  },

  ////////SSO登入API
  async ssoLogin(tempCode) {
    try {
      // 假設後端 SSO 換 Token 端點
      const response = await axiosInstance.get(`/org/nxstart/redirect`, {
        params: { code: tempCode },
        skipAuth: true,
      });

      if (response.data.error) {
        handleAPIError(null, {
          apiData: response.data,
          scenarioCode: MESSAGE_CODES.SSO_LOGIN_FAILED
        });
      }
      return response.data.data;
    } catch (err) {
      console.error("SSO Login Fail!", err);
      handleAPIError(err, {
        scenarioCode: MESSAGE_CODES.SSO_LOGIN_FAILED,
        throwError: false
      });
      throw err;
    }
  },

  ////////重設密碼API
  async resetPassword(token, newPassword, verifiedPassword) {
    try {
      const response = await axiosInstance.post(
        `/user/accountuser/reset-password`,
        { newPassword, verifiedPassword, token },
        { skipAuth: true },
      );
      if (response.data.error) {
        handleAPIError(null, { apiData: response.data });
      }
      return response.data.data;
    } catch (err) {
      console.error("Reset Password Fail!", err);
      handleAPIError(err, { throwError: false });
      throw err;
    }
  },

  ////////Forget password API
  async forgetPassword(email) {
    try {
      const response = await axiosInstance.post(
        `/user/accountuser/forget-password/${email}`,
        {},
        { skipAuth: true },
      );
      if (response.data.error) {
        handleAPIError(null, { apiData: response.data });
      }
      return response.data.data;
    } catch (err) {
      console.error("Forget Password Fail!", err);
      handleAPIError(err, { throwError: false });
      throw err;
    }
  },

  ////////登出API
  async logout() {
    try {
      const res = await axiosInstance.get(`/user/accountuser/logout`);
      showSuccessToast({
        apiData: res.data,
        scenarioCode: MESSAGE_CODES.LOGOUT_SUCCESS,
      });
    } catch (err) {
      console.error(err);
      // handleAPIError(err, "登出出現問題");
    }
  },

  ////////拿到authId,roleId,industryCode
  async getAuthIdAndRoleId(userId, authToken) {
    try {
      const response = await axiosInstance.get(
        `/org/orguser/${userId}/authorization`,
        { authToken },
      );
      if (response.data.error) {
        throw new Error(response.data.error);
      }
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "取得授權ID和角色ID失敗");
      console.error("Get AuthId and RoleId Fail!", err);
    }
  },

  ////////拿到類別公司清單
  async getOrgList(authId, authToken) {
    if (!authId) {
      throw new Error("getOrgList requires authId");
    }

    try {
      const response = await axiosInstance.get(
        `/org/organization/${authId}/descendants`,
        { authToken },
      );
      if (response.data.error) {
        throw new Error(response.data.error);
      }
      return response.data.data;
    } catch (err) {
      // handleAPIError(err, "拿到類別公司清單失敗");
      console.error("Get Org List Fail!", err);
    }
  },

  ////////拿到公司清單
  async getCompanyListAPI(userId, authToken) {
    try {
      const response = await axiosInstance.get(`/org/company/${userId}`, {
        authToken,
      });

      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching company list data:", error);
    }
  },

  async getUserScopeType(userId, authToken) {
    try {
      const response = await axiosInstance.get(
        `/org/orguser/scope_type/${userId}`,
        { authToken },
      );

      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching company list data:", error);
    }
  },
};
